import {Component, Input} from '@angular/core';
import {Product} from '@spartacus/core/src/model/product.model';
import {RoutingService} from '@spartacus/core';

@Component({
  selector: 'dcp-cancel-cta-button',
  templateUrl: './cancel-cta-button.component.html',
  styleUrls: ['./cancel-cta-button.component.scss']
})
export class CancelCtaButtonComponent {

  @Input() displayProduct: Product;
  @Input() buttonText: string = 'common.cancel';

  constructor(private routingService: RoutingService) {}
    
  redirectToProduct(): void {
    this.routingService.go({
      cxRoute: 'product',
      params: this.displayProduct,
    });
  }
}
